module.exports = __webpack_public_path__ + "activities_bg.cce998f2323c69392f2cd0de3827ae54.png";